import './BadgeOld.scss';

import { observer } from 'mobx-react-lite';

type Props = {
  badgeText?: string;
  badgeIcon?: React.ReactNode;
};

export const BadgeOld = observer(({ badgeText, badgeIcon }: Props) => {
  return (
    <div className='badge-old'>
      {badgeIcon && <span className='badge-icon-old'>{badgeIcon}</span>}
      <span>{badgeText}</span>
    </div>
  );
});

export default BadgeOld;
